<div class="row">

  <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0 Registration-split">
    <app-account-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-account-header>

    <div class="
          col-xs-12 col-sm-12 col-md-12
          Registration-split
          confirmation-split
        ">
      <h3 class="pdp-title">
        {{ "accountRegistration.accountConfirmation.title" | cxTranslate }}
      </h3>
      <span class="confirmation-txt">
        @if (baseSiteId == 'vsh') {
          <span>
          {{"accountRegistration.accountConfirmation.content" | cxTranslate}}</span>
        }
        @if (baseSiteId == 'vax') {
          <span>
          {{"accountRegistration.accountConfirmation.vaxServeContent" | cxTranslate}}</span>
        }
      </span><br /><br />
      <span class="confirmation-txt">{{
        "accountRegistration.accountConfirmation.sub_content" | cxTranslate
      }}</span>

      <div class="invoice-btngrps">
        <button type="button" class="btn-primary" data-di-id="di-id-41a05d18-6b04a424"
          [routerLink]="['/Open-Catalogue/c/1']">
          {{
          "accountRegistration.accountConfirmation.catalog_button"
          | cxTranslate
          }}
        </button>
      </div>
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2 Notify-Msg">&nbsp;</div>
</div>